// extracted by mini-css-extract-plugin
export default {"root":"NatRulesAddForm_root__ms9Ar","natInfo":"NatRulesAddForm_natInfo__UN5jf","alert":"NatRulesAddForm_alert__ioc9D","natTypeInput":"NatRulesAddForm_natTypeInput__V-S+o"};